import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const REVIEWS = [
  { name: "Google-Kunde", role: "Verifizierte Google-Rezension", rating: 5, text: "Erneut haben wir eine großartige Erfahrung mit der Firma S&P Reinigungsservice gemacht! Von Anfang an war der Kundenservice hervorragend – das Team hat schnell und flexibel reagiert." },
  { name: "Andrea K.", role: "Privatkundin · Esterwegen", rating: 5, text: "Absolut streifenfreie Fenster und ein super freundliches Team. Termin wurde pünktlich eingehalten – gerne wieder!" },
  { name: "Bäckerei Meyer", role: "Gewerbekunde · Sögel", rating: 5, text: "Unsere Schaufenster glänzen jetzt jede Woche. Zuverlässig, fair im Preis und immer erreichbar. Klare Empfehlung." },
  { name: "Thomas B.", role: "Hausverwaltung · Papenburg", rating: 5, text: "Treppenhausreinigung für mehrere Objekte – seit Monaten tadellos. Endlich ein Dienstleister, auf den Verlass ist." },
  { name: "Familie Wübbe", role: "Privatkunden · Werlte", rating: 5, text: "Nach dem Umzug alles besenrein übergeben bekommen, Kaution kam vollständig zurück. Vielen Dank für die saubere Arbeit!" },
  { name: "Solarhof GmbH", role: "Gewerbekunde · Lathen", rating: 5, text: "Unsere PV-Anlage wurde schonend gereinigt, der Ertrag ist spürbar gestiegen. Professionell von A bis Z." },
  { name: "Petra L.", role: "Privatkundin · Esterwegen", rating: 5, text: "Grundreinigung nach der Renovierung – aus staubig wurde makellos. Freundlich, gründlich und sehr sorgfältig." },
];

function Stars({ n }) {
  return (
    <div className="flex gap-0.5">
      {Array.from({ length: 5 }).map((_, i) => (
        <Star key={i} className={`h-4 w-4 ${i < n ? "fill-cyan-glass text-cyan-glass" : "text-white/20"}`} strokeWidth={1.5} />
      ))}
    </div>
  );
}

export default function Reviews() {
  return (
    <section id="rezensionen" className="relative bg-[#030712] py-28 md:py-36">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="mb-16 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-cyan-glass mb-5">Rezensionen</p>
            <h2 className="font-heading text-4xl md:text-6xl font-medium tracking-tight text-white max-w-2xl">
              Das sagen unsere Kunden
            </h2>
          </div>
          <div className="flex items-center gap-4">
            <Stars n={5} />
            <span className="font-mono text-sm text-white/60">5,0 · 85 Bewertungen</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {REVIEWS.map((r, i) => (
            <motion.div
              key={r.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.1, ease: [0.16, 1, 0.3, 1] }}
              data-testid={`review-card-${i}`}
              className="relative glass rounded-sm p-8 flex flex-col"
            >
              <Quote className="h-8 w-8 text-cyan-glass/30 mb-5" strokeWidth={1.4} />
              <p className="text-base font-light leading-relaxed text-white/75 flex-1">“{r.text}”</p>
              <div className="mt-7 pt-6 border-t border-white/10 flex items-center justify-between">
                <div>
                  <div className="font-heading text-white font-medium">{r.name}</div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.15em] text-white/40 mt-1">{r.role}</div>
                </div>
                <Stars n={r.rating} />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
